import { ApplicationState } from '../reducers';
import { MapInstanceState } from './map.reducer';
import { consolidateMapState, getProjectMapInstanceState } from '../selectors';

/**
 * Merge base map instance state with persisted per-project map state from the store
 * (same logic as coreo-mapbox-map getMapState, without UI side effects).
 */
export const resolvePersistedMapState = (
  initialState: MapInstanceState,
  applicationState: ApplicationState
): { resolved: MapInstanceState; shouldPersistToRedux: boolean } => {
  if (!initialState.id) {
    return { resolved: initialState, shouldPersistToRedux: false };
  }

  const storedMapState = getProjectMapInstanceState(initialState.id)(applicationState) ?? initialState;
  const { state, newLayers, newDataLayers, removed } = consolidateMapState(storedMapState)(applicationState);

  const baseStyleId = initialState.baseStyleId;
  const consolidatedWithBase: MapInstanceState = { ...state, baseStyleId };
  const storedWithBase: MapInstanceState = { ...storedMapState, baseStyleId };

  const shouldPersistToRedux =
    removed > 0 || newLayers.length > 0 || newDataLayers.length > 0;

  if (shouldPersistToRedux) {
    return { resolved: consolidatedWithBase, shouldPersistToRedux: true };
  }

  return { resolved: storedWithBase, shouldPersistToRedux: false };
};
